import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"

const solicitationRoutes: RouteRecordRaw[] = [
  {
    path: "/solicitations",
    redirect: { name: "notification-center" },
  },
  {
    path: "/solicitations/maj/:token",
    name: "maj-form",
    component: () => import("@/views/solicitations/CmajForm.vue"),
    meta: {
      middleware: [auth],
      title: "Compléter mes informations | Uska",
    },
  },
  {
    path: "/solicitations/adh/:token",
    name: "adh-form",
    component: () => import("@/views/solicitations/CadhForm.vue"),
    meta: {
      middleware: [auth],
      title: "Voir les offres | Uska",
    },
  },
]

export default solicitationRoutes
